<template>
  <v-app-bar app elevation="3">
    <img
      src="@/assets/logo.svg"
      class="logo mr-auto"
      :class="{ 'in-room': inRoom }"
      @click="
        !inRoom &&
          $router.push({ path: `${role == 'superuser' ? '/superuser' : '/'}` })
      "
    />

    <v-btn
      v-if="!inRoom && isLoggedIn && role == 'superuser'"
      small
      color="primary"
      class="mr-2"
      :lang="$i18n.locale"
      @click="$router.push({ path: '/shadow' })"
    >
      <v-icon left small>mdi-eye</v-icon>
      {{ $t('watchPresentation') }}
    </v-btn>

    <v-btn
      v-if="isLoggedIn"
      small
      depressed
      color="primary"
      class="mr-2"
      :lang="$i18n.locale"
      @click="onLogout"
    >
      {{ $t('logout') }}
      <v-icon right small> mdi-logout </v-icon>
    </v-btn>

    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          color="primary"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-web</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          link
          @click="onChangeLanguage(item)"
        >
          <v-list-item-title>
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";

export default {
  computed: {
    ...mapGetters(["isLoggedIn"]),
    ...mapState({
      role: (state) => state.auth.role,
    }),
    inRoom() {
      return this.$route.path.includes("/room/");
    },
  },
  data: () => ({
    items: [
      { title: 'Greek', icon: '$vuetify.icons.el_flag', lang: 'el' },
      { title: 'English', icon: '$vuetify.icons.en_flag', lang: 'en' },
      { title: 'Spanish', icon: '$vuetify.icons.es_flag', lang: 'es' }
    ]
  }),
  methods: {
    ...mapActions(["logout"]),
    ...mapMutations(["setAllowLeave"]),
    async onLogout() {
      await this.logout();

      if (this.inRoom) {
        this.setAllowLeave(true);
      }

      this.$router.push({ path: "/login" });
    },
    onChangeLanguage(item) {
      this.$i18n.locale = item.lang;
    }
  },
};
</script>

<style lang="scss" scoped>
.logo {
  height: 28px;

  &:not(.in-room) {
    cursor: pointer;
  }
}
</style>
